import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('heritage_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
